import { render, staticRenderFns } from "./MedSverka.vue?vue&type=template&id=4c70b3d6&scoped=true"
import script from "./MedSverka.vue?vue&type=script&lang=js"
export * from "./MedSverka.vue?vue&type=script&lang=js"
import style0 from "./MedSverka.vue?vue&type=style&index=0&id=4c70b3d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70b3d6",
  null
  
)

export default component.exports